import React from 'react'
import './icon.scss'

const svgIcons = require.context('./assets', false, /\.svg$/)

const icons = svgIcons.keys().reduce((acc, filePath) => {
    const iconName = filePath.replace('./', '').replace('.svg', '')
    acc[iconName] = svgIcons(filePath)
    return acc
}, {})

export default function Icon({ type, className, size, withShadow, style, onClick, isActive }) {
    const classList = ['icon']
    if (className) classList.push(className)
    if (size) classList.push(`icon--${size}`)
    if (withShadow) classList.push(`icon--shadow`)
    if (isActive) classList.push('icon--active')

    return (
        <svg className={classList.join(' ')} style={style} onClick={onClick} aria-label={`icon-${type}`} role="img">
            <use href={`#${type}`}></use>
        </svg>
    )
}

Icon.propTypes = {
    type: PropTypes.string,
    withShadow: PropTypes.bool,
    size: PropTypes.oneOf(['xxxs', 'xxs', 'xs', 'sm', 'smd', 'md', 'lg', 'xl', 'xxxl']),
}
